import React, { useState } from "react";
import { userApi, apiError } from "@/lib/userApi";
import { toast } from "sonner";
import { UserPlus, Check, Loader2 } from "lucide-react";

/** Botón «+» para enviar solicitud de amistad desde cualquier publicación o chat. */
export const FriendAddButton = ({ personKey, name, className = "" }) => {
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!personKey) return null;

  const send = async (e) => {
    e?.stopPropagation?.();
    setBusy(true);
    try {
      await userApi.post(`/social/friends/request/${personKey}`);
      setSent(true);
      toast.success(`Solicitud enviada a ${name || "este miembro"} (caduca en 7 días)`);
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <button data-testid={`friend-add-${personKey}`} onClick={send} disabled={busy || sent}
      title={sent ? "Solicitud enviada" : "Agregar amigo"}
      aria-label="Agregar amigo"
      className={`w-7 h-7 rounded-full border flex items-center justify-center shrink-0 transition-colors ${
        sent ? "border-emerald-400/50 text-emerald-300"
             : "border-red-400/50 text-red-300 hover:bg-red-500/15"
      } ${className}`}>
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" />
        : sent ? <Check className="w-3.5 h-3.5" /> : <UserPlus className="w-3.5 h-3.5" />}
    </button>
  );
};

export default FriendAddButton;
